module.exports = __webpack_public_path__ + "img/1+1-Tafel_alle.a4844e99.png";